import React from "react";
import InputFieldControl from "components/base/InputFieldControl";
import './GeneralPurchasePerMin.scss';

const GeneralPurchasePerMin = ({
  containerClassName,
  minSpendingTitle,
  minSpendingName,
  minQuantityTitle,
  minQuantityName,
}) => (
  <div className={`general-purchase-per-min-container ${containerClassName}`}>
    <InputFieldControl
      customTitleClass='general-purchase-min-spending-title'
      name={minSpendingName}
      title={minSpendingTitle}
      useDefaultFieldName
      type='number'
      per='HK$'
      className='coupon-campaign-section-input'
    />
    <InputFieldControl
      customTitleClass='general-purchase-min-quantity-title'
      name={minQuantityName}
      title={minQuantityTitle}
      useDefaultFieldName
      type='number'
      className='coupon-campaign-section-input'
      unit='Items'
    />
  </div>
)

export default GeneralPurchasePerMin;
